import { createContext } from 'react';

export type TourContextType = {
  isTourRunning: boolean;
  currentFlowId: string | null;
  isFlowCompleted: (flowId: string) => boolean;
  /**
   * Returns the next step index a user would resume on for a flow.
   * 0 means "not yet started" OR "completed" — use {@link isFlowCompleted}
   * to disambiguate.
   */
  getFlowProgress: (flowId: string) => number;
  startTour: (flowId: string) => void;
  stopTour: () => void;
  resetFlow: (flowId: string) => void;
  resetAllFlows: () => void;
};

export const TourContext = createContext<TourContextType>(
  {} as TourContextType
);
